export const cursorPosition = (event: any): number => (event.touches ? event.touches[0].clientX : event.clientX);
